<template>
  <pop-over position="bottom-center" class="filter-popover" size="300px">
    <div slot="clickTrigger">
      <button class="mds-button mds-button--flat filter-title" type="button">
        <span class="mds-button__text">{{ title }}</span>
        <svg class="mds-icon mds-button__icon mds-button__icon--right" aria-hidden="true">
          <use xlink:href="static/mds/icons/mds.svg#caret-down"></use>
        </svg>
      </button>
    </div>
    <span slot="header">{{ subtitle }}</span>
    <div slot>
      <form class="mds-form mds-form--medium-layout multiple-list">
        <div class="mds-form__field-group">
          <fieldset class="mds-form__checkbox-group" role="group">
            <check-box
              @input="onAllClick"
              :label="title"
              :value="allSelected"
              :disabled="disabled"
            />
            <check-box
              v-for="(item, index) in optionsList"
              :key="index"
              @input="onOptionClick($event, item)"
              :label="item.label"
              :value="isSelected(item.value)"
              :disabled="disabled"
            ></check-box>
          </fieldset>
        </div>
      </form>
    </div>
  </pop-over>
</template>
<script>
import PopOver from 'mds-vue/src/components/PopOver';
import CheckBox from '@/components/atoms/CheckBox';

export default {
  name: 'multi-list',
  components: {
    'check-box': CheckBox,
    'pop-over': PopOver,
  },
  props: ['optionsList', 'title', 'subtitle', 'selectedOptions', 'allSelected', 'disabled'],
  methods: {
    onOptionClick(event, item) {
      if (this.allSelected) {
        this.$emit('updateInvertedSelectedList', event, item.value);
      } else {
        this.$emit('updateSelectedList', event, item.value);
        if (this.selectedOptions.length === this.optionsList.length) {
          this.onAllClick();
        }
      }
    },
    onAllClick() {
      this.$emit('toggleSelectAll', !this.allSelected);
    },
    isSelected(value) {
      if (value !== '') {
        return this.selectedOptions.indexOf(value) !== -1 || this.allSelected;
      }
      return false;
    },
  },
};
</script>
<style lang="scss">
.filter-popover {
  z-index: 299;
  max-height: 400px;
  border: solid 1px $mds-color-neutral-50;
  margin-left: $mds-space-inset-2-x;
  button {
    padding-left: $mds-space-inset-1-and-a-half-x;
    padding-right: $mds-space-inset-1-and-a-half-x;
  }
}
.multiple-list {
  max-height: 300px;
  overflow: auto;
}
</style>
